import { MarketplaceEventProps } from '../events/properties';

export const getMarketplaceEventProps = (
  props: Partial<MarketplaceEventProps>
) => props;
